import React from "react";
import { Table, Tag, Button, Tooltip, Empty } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { StockTransfer } from "../../../Types";
import { PAGE_SIZE } from "../../../Constant";

interface Props {
  transfers: StockTransfer[];
  total: number;
  page: number;
  isLoading: boolean;
  onPageChange: (page: number) => void;
  onView: (rec: StockTransfer) => void;
}

export const StockTransfersTable: React.FC<Props> = ({
  transfers,
  total,
  page,
  isLoading,
  onPageChange,
  onView,
}) => {
  const columns = [
    {
      title: "Date",
      dataIndex: "created_at",
      width: 150,
      render: (val: string) => (
        <span className="text-xs text-gray-500">
          {dayjs(val).format("DD MMM YYYY, hh:mm A")}
        </span>
      ),
    },
    {
      title: "Transfer No",
      dataIndex: "transfer_no",
      width: 140,
      render: (val: string) => (
        <span className="font-medium text-gray-800 text-sm">{val}</span>
      ),
    },
    {
      title: "Source",
      dataIndex: "from_store_name",
      render: (val: string) => <Tag color="blue">{val}</Tag>,
    },
    {
      title: "Destination",
      dataIndex: "to_store_name",
      render: (val: string) => <Tag color="purple">{val}</Tag>,
    },
    {
      title: "Items",
      key: "items_count",
      width: 70,
      align: "center" as const,
      render: (_: any, r: any) => <Tag>{r.items?.length || 0}</Tag>,
    },
    {
      title: "Operator",
      dataIndex: "creator_name",
      width: 120,
      render: (val: string) => (
        <span className="text-xs text-gray-500">{val || "—"}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 100,
      render: (val: string) => (
        <Tag color="green" className="text-xs">
          {val}
        </Tag>
      ),
    },
    {
      key: "actions",
      width: 56,
      align: "center" as const,
      render: (_: any, record: StockTransfer) => (
        <Tooltip title="View details">
          <Button
            icon={<InfoCircleOutlined />}
            size="small"
            type="text"
            onClick={() => onView(record)}
            className="text-gray-400"
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-100">
      <Table
        dataSource={transfers}
        columns={columns}
        rowKey="id"
        loading={isLoading}
        size="middle"
        pagination={{
          current: page,
          pageSize: PAGE_SIZE,
          total,
          onChange: onPageChange,
          showSizeChanger: false,
        }}
        scroll={{ x: 850 }}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No stock transfer records."
            />
          ),
        }}
      />
    </div>
  );
};
